import React, { useState, useEffect } from 'react';

import CheckboxComponent from '../../../../Form/Checkbox';

export default function Checkbox({ col, row, value, readOnly }) {
  const [isChecked, setIsChecked] = useState(value);

  useEffect(() => {
    setIsChecked(value);
  }, [value]);

  return (
    <CheckboxComponent
      onChange={(event) => {
        col.onChange(event.target.checked, row);
        setIsChecked(event.target.checked);
      }}
      value={isChecked}
      disabled={readOnly}
    />
  );
}
